import React from 'react';
import { Button, Modal, Input } from 'semantic-ui-react';
import Load from '../../load';
import server from '../../functions/server';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import $ from 'jquery';

export default class Expense extends React.Component {

  state = {
    addExpenseDialog: false,
  }

  onChangeHandle = (key) => event => {
    this.setState({ [key]: event.target.value })
  }

  addExpense() {
    let context = this;
    if (!this.state.expensename) {
      alert('Enter Expense Name Properly');
      return;
    }
    let data = { name: context.state.expensename, shop_id: context.props.shopId };
    let url = server()+'/monthlyexpenses/master/add.php';
    $.ajax({
      url, data, type: 'POST',
      beforeSend: function(x) { context.setState({ load: true }); }
    }).done((data) => {
      try {
        data = Number(data);
        if (data === "0") {
          alert('Error to Add Data');
          return;
        }
        else {
          context.props.updateItem('add', data, context.state.expensename);
          context.setState({ expensename: '', addExpenseDialog: false })
        }
      } catch (e) {
        alert('Error to Add Data');
      }
    });
  }


  render() {
    return (
      <div>
        <Button primary style={{marginTop: 5, marginLeft: 2}} onClick={ () => { this.setState({ addExpenseDialog: true }) }}>Add Expense</Button>
          <Dialog
            fullWidth={true}
            maxWidth={'sm'}
            open={this.state.addExpenseDialog}
            onClose={() => this.setState({ addExpenseDialog: false })}
            aria-labelledby="max-width-dialog-title"
          >
          <DialogTitle id="max-width-dialog-title">Add Expense</DialogTitle>
          <DialogContent>
            <Input fluid placeholder="Expense Name"
              value={this.state.expensename} onChange={this.onChangeHandle('expensename')} />
          </DialogContent>
          <DialogActions>
            <Button negative onClick={ () => { this.setState({ addExpenseDialog: false }) }}>Close</Button>
            <Button positive icon='checkmark' labelPosition='right' content='Save' onClick={this.addExpense.bind(this)}/>
          </DialogActions>
        </Dialog>
        <Load load={this.state.load} message={this.state.message} />
      </div>
    );
  }
}
